






























import {
  Vue,
  Component,
  Prop,
  Watch
} from "@/shared/vuepack";
import Wizard from "@/employer/components/profile/Wizard.vue";
import ProgressIndicator from "@/shared/components/ProgressIndicator.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import PartnerCreateEmployer from "@/employer/components/user-management/PartnerCreateEmployer.vue";
import { Location } from "vue-router";
import { ProfileWizardSteps } from "@/employer/types";
import {
  PartnerCreateEmployerEvent,
  UserRole
} from "@/shared/types";
import * as userService from "@/shared/api/userService";
import { useNotifierStore } from "@/shared/store/notifier";
import { useProfileStore } from "@/employer/store/profile";
import { useUserStore } from "@/shared/store/user";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

@Component({
  components: {
    ProgressIndicator,
    Wizard,
    PartnerCreateEmployer,
    GenericLoadingSpinner,
  }
})
export default class NewEmployer extends Vue {
  profileStore = useProfileStore();
  userStore = useUserStore();
  featureFlagStore = useFeatureFlagStore();
  notifierStore = useNotifierStore();

  employerHsaSteps = [ "ACCOUNT CREATION", "EMPLOYER DETAILS", "PLAN DETAILS", "PAYROLL CYCLE SETUP", "FINISH" ] as any;
  createEmployerData: PartnerCreateEmployerEvent = null;

  get hasSignedUp () {
    return this.employerId > 0;
  }

  get innerStep () {
    return !this.step || isNaN(this.step) ? 0 : this.step;
  }

  @Prop()
  partnerId: number;

  @Prop()
  step: number;

  @Prop()
  goToStep: (employerId: number, step: number, edit: boolean) => Location;

  @Prop()
  employerId: number;

  @Prop()
  routeToFinish: () => Location;

  @Prop()
  routeToWizardComplete: () => Location;

  @Prop()
  edit: boolean;

  @Prop()
  employerName: string;

  @Watch("step")
  onRouteValueStepChanged (newStep, oldStep) {
    if (oldStep !== newStep && newStep === ProfileWizardSteps.Finish) {
      this.addUser();
      if (this.profileStore.isOnboarded) {
        this.profileStore.setCurrentStep(oldStep);
        return;
      }
    }

    this.profileStore.setCurrentStep(this.innerStep);
  }

  created () {
    this.profileStore.setEmployer(null);
    this.userStore.setEmployerId(null);

    if (this.hasSignedUp === false && this.step !== 0) {
      this.$router.push(this.goToStep(0, 0, this.edit));
    }
  }

  addUser () {
    if (this.createEmployerData && this.createEmployerData.initialUser) {
      const initialUser = this.createEmployerData.initialUser;
      const initialRoles: string[] = [ UserRole.EmployeeManager, UserRole.EmployerOwner ];
      this.createEmployerData.initialUser = null;

      userService.addEmployerUser({
        employerId: this.employerId,
        firstName: initialUser.firstName,
        lastName: initialUser.lastName,
        email: initialUser.email,
        roles: initialRoles,
        phone: "",
        jobTitle: ""
      }).catch(err => this.notifierStore.error(err));
    }
  }

  beforeDestroy () {
    this.profileStore.setEmployer(this.userStore.employerId);
  }

  get maxAllowedClickIndex () {
    return this.hasSignedUp ? this.profileStore.maxAllowedStep : 0;
  }

  progressLink (index: number) {
    return this.goToStep(this.employerId, index, this.edit);
  }

  onSignupComplete (eventPayload: PartnerCreateEmployerEvent) {
    this.createEmployerData = eventPayload;
    this.$router.push(this.goToStep(eventPayload.employerId, 1, this.edit));
  }

  get showFundingMethod () {
    return this.featureFlagStore.flags.showFundingMethod;
  }

  get isLoaded () {
    return this.featureFlagStore.featureFlagsAvailable;
  }
}

